// extracted by mini-css-extract-plugin
module.exports = {"container":"successMessage_container__cC9y5","close":"successMessage_close__tFjrH","message":"successMessage_message__zGdl2","image":"successMessage_image__PWAzp"};